import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Paper from 'apollo-react/components/Paper';
import React from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';

import { closePopupWindowDialog } from '../actions/EntityDisplayActions';

const useStyles = makeStyles({
  paper: {
    width: '90vw',
    maxWidth: '90vw',
    height: '90vh',
    maxHeight: '90vh',
    '& [class*="MuiDialogContent"]': {
      paddingTop: 30,
    },
  },
  contentRoot: {
    borderRadius: '4px',
    height: '100%',
    overflow: 'hidden',
  },
  draggableTitle: {
    width: '100%',
    height: 50,
    position: 'absolute',
    cursor: 'move',
  },
});

const PopupWindowDialog = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const popupWindow = useSelector((state) => state.entityDisplayPage.popupWindow) || {};

  const handleClose = () => {
    dispatch(closePopupWindowDialog());
  };

  return (
    <div>
      <Modal
        open={!!popupWindow.visible}
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
        onClose={handleClose}
        hideButtons
        title=""
        classes={{
          paper: classes.paper,
        }}
        PaperComponent={(paperProps) => (
          <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...paperProps}>
              <div id="draggable-dialog-title" className={classes.draggableTitle} />
              {paperProps.children}
            </Paper>
          </Draggable>
        )}
        aria-labelledby="draggable-dialog-title"
      >
        <div className={classes.contentRoot}>
          <iframe
            src={popupWindow.url}
            width="100%"
            height="100%"
            frameBorder="0"
            title="Popup window"
          />
        </div>
      </Modal>
    </div>
  );
};

export default PopupWindowDialog;
